module.exports = __webpack_public_path__ + "img/sc-gallery-3.9fccfa74.jpg";